import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, Briefcase, Send, Mic, Trophy, Flag, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";

export const CareerPipeline = ({ refreshKey = 0 }) => {
  const [p, setP] = useState(null);

  useEffect(() => {
    api.get("/applications/pipeline").then(({ data }) => setP(data)).catch(() => {});
  }, [refreshKey]);

  if (!p) return null;

  const stages = [
    { icon: FileText, label: "CV", value: p.cv.count, to: "/builder/cv", done: p.cv.count > 0, sub: p.cv.latest_title || "Not created" },
    { icon: Briefcase, label: "Jobs saved", value: p.stages.saved + p.stages.preparing, to: "/applications", done: p.stages.saved + p.stages.preparing > 0, sub: "Saved + preparing" },
    { icon: Send, label: "Applied", value: p.stages.applied, to: "/applications", done: p.stages.applied > 0, sub: "Applications live" },
    { icon: Mic, label: "Interview", value: p.stages.interview, to: "/applications", done: p.stages.interview > 0, sub: "In play" },
    { icon: Trophy, label: "Offer", value: p.stages.offer, to: "/applications", done: p.stages.offer > 0, sub: "Offers received" },
    { icon: Flag, label: "Outcome", value: p.outcomes, to: "/applications", done: p.outcomes > 0, sub: "Closed loops" },
  ];

  return (
    <div className="mt-4 rounded-2xl border border-border bg-card p-5" data-testid="career-pipeline">
      <div className="flex items-center justify-between gap-2">
        <p className="text-sm font-medium">Your career journey — one connected pipeline</p>
        <span className="text-xs text-muted-foreground">{p.total} tracked</span>
      </div>
      <div className="mt-3 flex items-stretch gap-1 overflow-x-auto pb-1">
        {stages.map((s, i) => (
          <div key={s.label} className="flex items-center">
            <Link to={s.to} data-testid={`pipeline-stage-${s.label.toLowerCase().replace(/ /g, "-")}`}
              className={`flex min-w-[92px] flex-col items-center rounded-xl border px-2.5 py-2.5 text-center transition-colors hover:border-primary/50 ${s.done ? "border-primary/40 bg-primary/5" : "border-border bg-background"}`}>
              <s.icon className={`h-4 w-4 ${s.done ? "text-primary" : "text-muted-foreground"}`} />
              <span className="mt-1 text-lg font-semibold leading-none">{s.value}</span>
              <span className="mt-0.5 text-[11px] font-medium">{s.label}</span>
              <span className="max-w-[88px] truncate text-[10px] text-muted-foreground">{s.sub}</span>
            </Link>
            {i < stages.length - 1 ? <ChevronRight className="mx-0.5 h-4 w-4 shrink-0 text-muted-foreground/50" /> : null}
          </div>
        ))}
      </div>
      <p className="mt-3 rounded-xl bg-background px-3 py-2 text-xs text-muted-foreground" data-testid="pipeline-next-hint">
        ➡️ {p.next_hint}
      </p>
    </div>
  );
};
